import React, { useEffect } from "react";
import { t } from "i18next";
import ServerImage from "components/server-image/server-image";
import { json } from "helpers/data";
import { Button } from "components/form";
import { useStatus } from "hooks/use-status";
import _ from "lodash";

const PricingCard = ({ onChangeVersion, onChangeRelease, onChangeCountryPay, version, subscriptionType }) => {
  const { isLoading } = useStatus();

  const handleBuyNow = (id, versionReleaseId, paymentCountryId) => {
    onChangeVersion(id);
    onChangeRelease(versionReleaseId);
    onChangeCountryPay(paymentCountryId);
  };
  useEffect(() => {
    finalPrice();
  });

  const finalPrice = () => {
    let priceArry = Object.values(version?.price).filter((item) => item !== null);
    if (!_.isEmpty(priceArry)) {
      return priceArry?.find((el) => el.discrimination === subscriptionType);
    }
  };

  return (
    <div className={version.isHighlightedVersion ? "pricingCard active" : "pricingCard "}>
      <ServerImage className={"logo"} src={version.image.fullPath} />
      <h2 className="title">{json(version.name)}</h2>
      <span className="version">{version?.releaseNumber}</span>

      <h2 className="price">
        {finalPrice()?.netPrice} <span>{json(`${finalPrice()?.currencySymbol ?? " "}`)}</span>
      </h2>

      <h2 className="oldPrice">{finalPrice()?.discountPercentage > 0 && finalPrice()?.priceBeforeDiscount} </h2>
      {finalPrice()?.netPrice > 0 ? (
        <Button
          isLoading={isLoading}
          className="btn-White"
          onClick={() => handleBuyNow(version?.id, version?.versionReleaseId, version?.paymentCountryId)}
          form="hook-form"
        >
          {t("details:addonDetails.buyNow")}
        </Button>
      ) : (
        <Button disabled={true} className="btn-blue">
          {t("details:addonDetails.notAvailable")}
        </Button>
      )}
    </div>
  );
};

export default PricingCard;
